<template>
    <div :style="`font-size: ${fontSize}rem;margin-top:${top}rem;margin-bottom:${bottom}rem;`" class="homeText">
        {{text}}
    </div>
</template>
<script>
export default {
    props:{
        text:{
            default:'请设置文本内容'
        },
        fontSize:{
            default:0.8
        },
        top:{
            default:2
        },
        bottom:{
            default:2
        },
    }
}
</script>
<style lang="less" scoped>
.homeText{
    margin: 0 auto;
    text-align: center;
    width: 73vw;
    color: #737373;
    line-height: 1.6rem;
}
</style>

